import React from 'react';

import { Body } from '@depop/web-thrift-ui/Typography';
import { Button } from '@depop/web-ui-kit/Button';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

const DEPOP_CLOUDFRONT_HOST = process.env.NEXT_PUBLIC_DEPOP_CLOUDFRONT_HOST;

type Props = { username: string; onExitClick: () => void };

export function CounterOfferModalSuccess({ username, onExitClick }: Props) {
  const t = useTranslations('offers');

  return (
    <div className={styles.counterOfferModalSuccessContainer}>
      <img
        src={`${DEPOP_CLOUDFRONT_HOST}/web/assets/make-offer-spin-sticker.gif`}
        height={188}
        width={188}
        alt=""
      />
      <Body
        variant="sm-regular"
        className={styles.counterOfferModalSuccessText}
      >
        {t.rich('CounterOfferModal.CounterOfferSent.Buyer', {
          bold: () => (
            <Body variant="sm-bold" as="span">
              {username}
            </Body>
          ),
        })}
      </Body>
      <Button
        className={styles.counterOfferModalSuccessButton}
        onClick={onExitClick}
      >
        {t('HelpExitButton')}
      </Button>
    </div>
  );
}
